import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "../service/auth/auth.guard";

const appRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "login",
        component: LoginComponent
      },
      // {
      //   path: "",
      //   redirectTo: "login",
      //   pathMatch: "full"
      // }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  declarations: [],
  exports: [RouterModule]
})
export class UserRoutingModule { }
